<template>
  <div class="options-menu-editor main">
    <div class="wrapper">
      <!-- <button class="delete is-large" @click="close" /> -->

      <span v-if="condition" class="is-pulled-right" @click="openCondition">
        <span style="color: grey">Condition:</span>&nbsp;
        <span class="link has-text-black">{{ condition }}</span>
      </span>

      <span v-if="type" class="is-pulled-right" @click="showSettings = true">
        <span style="color: grey">Type:</span>&nbsp;
        <span class="link has-text-black">{{ type }}</span>
      </span>

      <p class="subtitle">
        <i
          class="fa fa-chevron-left"
          style="padding-right: 4px"
          @click="close"
        />
        Options Editor
      </p>

      <div
        v-if="parentItemID"
        class="notification is-dark"
        @click="parentItemInfo"
      >
        Parent item: {{ parentItemID }}
      </div>

      <div class="field is-grouped">
        <div class="control is-expanded">
          <input
            ref="input"
            class="input"
            type="text"
            v-model="name"
            placeholder="Name (e.g. Sugar Level)"
          />
          <i class="input-label">Title</i>
        </div>
        <div class="control">
          <span
            class="buttons is-pulled-right is-uppercase"
            style="margin-top: 4px"
          >
            <span
              v-for="l in languages"
              :key="l"
              class="button is-small is-rounded"
              :class="
                contentLang === l
                  ? 'has-text-weight-medium'
                  : 'is-white has-text-grey'
              "
              @click="setContentLang(l)"
              >{{ l }}</span
            >
          </span>
        </div>
      </div>

      <div v-if="isShowInstruction" class="field">
        <div class="control">
          <input
            class="input"
            type="text"
            v-model="instruction"
            placeholder="Instruction or description"
          />
          <i class="input-label">Instruction</i>
        </div>
      </div>
      <div class="notification">
        <div class="field">
          <div class="control">
            <label class="radio">
              <input
                type="radio"
                name="required"
                :value="false"
                v-model="required"
              />
              Optional </label
            >&nbsp;
            <label class="radio">
              <input
                type="radio"
                name="required"
                :value="true"
                v-model="required"
              />
              Required
            </label>
          </div>
        </div>
        <div class="field is-grouped">
          <div class="control">
            <a
              class="button"
              :class="{ 'is-info': select === 'single' }"
              @click="select = 'single'"
            >
              Single
            </a>
          </div>
          <div class="control">
            <a
              class="button"
              :class="{ 'is-info': select === 'multiple' }"
              @click="select = 'multiple'"
            >
              Multiple
            </a>
          </div>
          <div v-if="!select" class="control">
            <a
              class="button is-light is-small has-text-danger"
              style="padding: 0"
              @click="select = 'multiple'"
            >
              <i class="fa fa-long-arrow-alt-left fa-2x" />
            </a>
          </div>
        </div>
        <div v-if="select === 'multiple'" class="field">
          <span
            class="button is-light is-capitalized"
            @click="showMultipleOptions = true"
          >
            <span class="link">
              <span v-if="multipleConstraintNone">No Constraint</span>
              <span v-else> {{ multipleConstraint }} : {{ multipleN }}</span>
            </span>
            <i
              v-if="!multipleConstraintNone && !multipleN"
              class="has-text-danger"
              >&nbsp;!!!</i
            > </span
          >&nbsp;
          <span class="button is-light">
            <label class="radio">
              <input
                type="checkbox"
                name="allowMultiple"
                :value="true"
                v-model="allowMultiple"
              />
              >1
            </label>
          </span>
        </div>
      </div>

      <div ref="scrollable" class="menu no-scrollbar gpu-accelerated">
        <div v-for="(o, i) in items" :key="i" class="item">
          <div class="field has-addons">
            <div class="control is-expanded">
              <input
                class="input is-light"
                v-model="o.name"
                placeholder="Item Name"
              />
              <span
                v-if="o.out_of_stock"
                class="tag is-danger"
                style="
                  position: absolute;
                  right: 0px;
                  top: 7px;
                  opacity: 0.7;
                  padding: 3px;
                "
                @click="errorToast('Out of stock', 'top')"
                >Out of stock</span
              >
            </div>
            <div class="control has-icons-left">
              <span
                class="icon is-small is-left"
                style="width: 25px; color: grey"
                >{{ currency }}</span
              >
              <input
                class="input is-light"
                style="width: 75px; padding-left: 18px; padding-right: 0"
                v-model="o.price"
                type="number"
                placeholder="Price"
              />
            </div>
            <div class="control">
              <a
                class="button is-light"
                style="padding: 4px 4px"
                @click="deleteMenuItem(i)"
              >
                <i class="fa fa-times-circle" />
              </a>
            </div>
          </div>
          <div
            v-if="showDescriptions"
            class="control notes"
            style="margin-top: -13px"
          >
            <p
              style="background-color: lightyellow"
              @click="editDescription(o)"
            >
              <span v-if="o.description">{{ o.description }}</span>
              <span v-else class="hint"
                ><i class="fa fa-pencil-alt" />&nbsp;Item description</span
              >
            </p>
          </div>
        </div>
        <!-- </div> -->
        <div
          class="has-text-right has-text-weight-medium"
          style="margin: 6px 0"
        >
          <!-- <span
          class="button is-white has-text-grey is-pulled-left is-capitalized"
          @click="showMultipleOptions = true"
          ><span class="link">
            <span v-if="multipleConstraintNone">No Constraint</span>
            <span v-else>
              {{ multipleConstraint }} : {{ multipleN }}</span
            ></span
          ></span
        > -->
          <span
            class="button is-white has-text-grey"
            @click="showSettings = !showSettings"
            >Zeros show as&nbsp;
            <span class="link has-text-black">
              {{ zerosShowAs }}
            </span>
          </span>
        </div>
      </div>

      <!-- <div style="height: 900px" /> -->

      <div class="bottom is-flex">
        <span
          class="button is-rounded"
          style="padding: 10px; flex-shrink: 1"
          @click="deleteOptionsMenu"
        >
          <i class="far fa-trash-alt has-text-grey" /> </span
        >&nbsp;
        <span
          class="button is-link is-outlined is-rounded"
          style="padding: 10px; flex: 1"
          @click="addItemToMenu"
        >
          <i class="fa fa-plus" />&nbsp;Add Item </span
        >&nbsp;
        <span
          class="button is-success is-outlined is-rounded"
          style="flex: 1"
          :disabled="disableSave"
          @click="saveOptionsMenu(true)"
        >
          <i class="fa fa-save" />&nbsp;Save </span
        >&nbsp;
        <span
          class="button is-rounded"
          style="padding: 10px; flex-shrink: 1"
          @click="showSettings = !showSettings"
        >
          <i class="fa fa-cog" />
        </span>
      </div>
    </div>

    <div v-if="showMultipleOptions" class="settings-main">
      <div class="settings-wrapper notification is-light">
        <p class="subtitle" style="margin-bottom: 16px">
          Multiple Options
          <button
            class="delete is-large is-pulled-right"
            @click="showMultipleOptions = false"
          />
        </p>
        <div v-if="!multipleConstraint">
          <p style="margin-bottom: 10px">
            <span class="button" @click="multipleConstraint = 'none'">
              No Constraint
            </span>
          </p>
          <p style="margin-bottom: 10px">
            <span class="button" @click="multipleConstraint = 'up_to'">
              Choose Up To ...
            </span>
          </p>
          <p style="margin-bottom: 10px">
            <span class="button" @click="multipleConstraint = 'exactly'">
              Choose Exactly ...
            </span>
          </p>
        </div>
        <div v-else>
          <div v-if="multipleConstraint === 'none'">
            <a
              class="button has-text-weight-medium"
              @click="multipleConstraint = null"
              ><i class="fa fa-times-circle has-text-grey" />&nbsp;No
              Constraint</a
            >
            <a
              class="button is-light has-text-grey"
              @click="select = 'multiple'"
            >
              <i class="fa fa-long-arrow-alt-left fa-lg" />&nbsp; Click to
              change
            </a>
          </div>
          <div v-else class="field has-addons">
            <div class="control" @click="multipleConstraint = null">
              <a class="button has-text-weight-medium">
                <i class="fa fa-times-circle has-text-grey" />&nbsp;
                <span v-if="multipleConstraint === 'up_to'">Choose Up To</span>
                <span v-else>Choose Exactly</span>
              </a>
            </div>
            <div class="control is-expanded">
              <input
                class="input"
                :class="{ 'is-danger': !multipleN }"
                type="number"
                v-model="multipleN"
              />
            </div>
          </div>
        </div>

        <p class="has-text-right" @click="saveSettings">
          <i class="button is-light has-text-link">Remember to save</i>
        </p>
      </div>
    </div>

    <div v-if="showSettings" class="settings-main">
      <div class="settings-wrapper notification is-light">
        <p class="subtitle">
          Options Settings&nbsp;
          <span
            v-if="$store.getters.isSuperUser"
            class="link advanced-settings"
            @click="toggleAdvancedSettings"
          >
            Advanced
          </span>
          <button
            class="delete is-large is-pulled-right"
            @click="closeSettings"
          />
        </p>
        <p
          v-if="showAdvancedSettings"
          class="buttons"
          style="
            background-color: #ddd;
            padding: 8px;
            padding-bottom: 0;
            border-radius: 4px;
          "
        >
          <span
            class="button"
            :class="{ 'is-info': condition }"
            @click="openCondition"
            >Condition</span
          >
          <span
            class="button"
            :class="{ 'is-info': type === 'time' }"
            @click="toggleTime"
            >Time</span
          >
          <span
            class="button"
            :class="{ 'is-info': type === 'date' }"
            @click="toggleDate"
            >Date</span
          >
          <span v-if="m" class="button" @click="preDuplicateOptions"
            >Duplicate</span
          >
        </p>
        <p><i class="button is-light pl-0">Show zeros as</i></p>
        <p class="buttons">
          <!-- <i class="button is-light pl-0">Show zeros as</i> -->
          <span
            class="button"
            :class="{ 'is-link': showZero && !zerosAs }"
            @click="
              showZero = true;
              zerosAs = null;
            "
            >{{ currency }}0</span
          >
          <span
            class="button"
            :class="{ 'is-link': !showZero && !zerosAs }"
            @click="
              showZero = false;
              zerosAs = null;
            "
            >FREE</span
          >
          <span
            class="button"
            :class="{ 'is-link': zerosAs === 'Select' }"
            @click="
              showZero = true;
              zerosAs = 'Select';
            "
            >Select</span
          >
          <span
            class="button"
            :class="{ 'is-link': zerosAs === 'Confirm' }"
            @click="
              showZero = true;
              zerosAs = 'Confirm';
            "
            >Confirm</span
          >
          <span
            class="button"
            :class="{ 'is-link': zeroIsOther }"
            @click="setZerosAs"
          >
            {{ "Other" }}
            <i v-if="zeroIsOther">&nbsp;- {{ zerosAs }}</i>
          </span>
        </p>

        <p>
          <i class="button is-light pl-0">Show instruction</i>
        </p>
        <p class="buttons">
          <span
            class="button"
            :class="{ 'is-link': isShowInstruction }"
            @click="showInstruction"
            >Yes</span
          >
          <span
            class="button"
            :class="{ 'is-link': !isShowInstruction }"
            @click="hideInstruction"
            >No</span
          >
        </p>

        <!-- <p class="buttons">
        <i class="button is-light pl-0">Descriptions</i>
        <span
          class="button"
          :class="{ 'is-success': showDescriptions }"
          @click="showDescriptions = true"
          >ON</span
        >
        <span
          class="button"
          :class="{ 'is-danger': !showDescriptions }"
          @click="showDescriptions = false"
          >OFF</span
        >
      </p> -->

        <p style="margin-bottom: 2px">
          <i class="button is-light pl-0">Click out of stock</i>
          <i class="button is-light is-pulled-right pr-0">Drag to re-order</i>
        </p>
        <div class="list no-scrollbar" :key="z">
          <draggable
            v-model="items"
            handle=".handle"
            @start="drag = true"
            @end="drag = false"
            @change="dragged"
          >
            <div
              v-for="(o, i) in items"
              :key="i + '2'"
              class="list-item"
              :class="{ 'bg-pink': o.out_of_stock }"
              @click="toggleOutOfStock(o)"
            >
              <span class="item-name">{{ o.name || "Unknown Item" }}</span>
              <span class="is-pulled-right">
                <!-- <span @click="toggleOutOfStock(o)">
                <span v-if="o.out_of_stock" class="tag has-text-danger"
                  >Out of Stock</span
                >
                <span v-else class="tag has-text-success">Available</span>
              </span>
              &nbsp; -->
                <span class="tag is-rounded handle">
                  <i class="fa fa-grip-lines fa-lg" style="padding: 0 6px" />
                </span>
              </span>
            </div>
          </draggable>
        </div>

        <p class="has-text-right" @click="saveSettings">
          <i class="button is-light has-text-link">Remember to save</i>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";

const shortid = require("shortid");

export default {
  name: "OptionsMenuEditor",
  components: {
    draggable,
  },
  props: {
    m: Object, // optionsMenu object
    business: Object,
    workflow: Object,
    opts: Object, // options like parent_item_id
  },
  data() {
    return {
      showMultipleOptions: false,
      contentLang: "en", // default English
      parentItemID: null, // set in opts
      type: null, // time, date, etc << special option menu type
      condition: null,
      name: null,
      select: "single", //null,
      items: [], // menu items
      required: false,
      showZero: true, // default is now 0, not FREE
      zerosAs: null, // Confirm, Select, etc
      instruction: null,
      multipleConstraint: "none", // none, up_to, exactly
      multipleN: 1,
      allowMultiple: false,
      names: {}, // names.en, names.th
      instructions: {},
      showSettings: false,
      showDescriptions: false,
      isShowInstruction: false,
      showAdvancedSettings: false,
      z: 0,
      zz: 0,
    };
  },
  computed: {
    multipleConstraintNone() {
      return !this.multipleConstraint || this.multipleConstraint === "none";
    },
    zeroIsOther() {
      if (!this.zeroAs) return false;
      var arr = ["Confirm", "Select"];
      return !arr.includes(this.zeroAs);
    },
    currency() {
      return this.currencySymbol(this.business.country);
    },
    zerosShowAs() {
      if (this.zerosAs) return this.zerosAs;
      if (this.showZero) return `${this.currency}0`;
      return "FREE";
    },
    disableSave() {
      if (!this.name) return true;
      if (!this.select) return true;
      return false;
    },
    languages() {
      return this.workflow.data.languages || ["en", "th"]; // otherwise show default languages...
    },
  },
  mounted() {
    // could update the options menu from DB first to be safe
    this.init();
    if (!this.items.length) this.addItemToMenu();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    setType(type) {
      // e.g. time / date, delivery_time, booking_time
      this.type = type;
    },
    parentItemInfo() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        Parent Item Info</p>
        <p style='margin-bottom:10px'>This Options Menu is associated with the parent menu item:
        </p>
        <p style='margin-bottom:10px'><b>${this.parentItemID}</b></p>
        <p>This means it cannot be used by other menu items.</p>
        </div>`,
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: "Use with other items",
      }).then((val) => {
        if (val.dismiss === "cancel") this.parentItemID = null;
      });
    },
    showInstruction() {
      // this.instruction = "Enter instruction";
      this.isShowInstruction = true;
      this.closeSettings();
      setTimeout(() => {
        var msg = `Edit instruction field below title <i class='fa fa-arrow-down'></i>`;
        this.infoToast(msg, "top");
      }, 500);
    },
    hideInstruction() {
      this.$swal({
        html: `<div>
        <p>Delete instruction?</p>
        </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Yes, Delete",
        confirmButtonColor: this.bulmaColor("danger"),
      }).then((val) => {
        if (val.value) {
          this.isShowInstruction = false;
          this.instruction = null;
          this.instructions = {};
          this.closeSettings();
        }
      });
    },
    closeSettings() {
      this.showSettings = false;
      this.warningToast("Remember to save any changes");
    },
    toggleAdvancedSettings() {
      this.showAdvancedSettings = !this.showAdvancedSettings;
    },
    openCondition() {
      this.showSettings = false;
      // var current = null;
      // if (this.m && this.m.data.advanced) {
      //   current = this.m.data.advanced.condition || null;
      // }
      this.$swal({
        //  <p style='margin-bottom:10px'>Ask Nick to set this up for you.</p>
        html: `<div style='text-align:left; color:violet'>
        <p style='font-size:1.2em; margin-bottom:10px'>Options Menu Condition</p>
        <p style='margin-bottom:10px'><i>Enter a condition, e.g. large</i></p>
        </div>`,
        input: "textarea",
        inputValue: this.condition || null,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t("submit"),
        cancelButtonText: "Clear",
        background: "black",
        inputValidator: (val) => {
          if (!val) return "Enter a value or press Clear";
        },
      }).then((val) => {
        if (val.dismiss === "cancel") {
          this.condition = null;
          this.infoToast("Condition removed, remember to save");
        }
        if (val.value) {
          this.condition = val.value.toLowerCase();
          this.infoToast("Condition updated, remember to save");
        }
      });
    },
    toggleTime() {
      if (this.type === "time") this.type = null;
      else this.type = "time";
    },
    toggleDate() {
      if (this.type === "date") this.type = null;
      else this.type = "date";
    },
    saveSettings() {
      this.showSettings = false;
      this.saveOptionsMenu(false);
    },
    dragged() {
      // this.zz += 1;
    },
    setZerosAs() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>Set Zeros As...</p>
        <p>Zero values will appear as "Select" or "Confirm" or any text you prefer.</p>
        </div>`,
        input: "text",
        inputValue: this.zerosAs,
        inputPlaceholder: "Select, Confirm, I Agree",
        showCloseButton: true,
        confirmButtonText: this.$t("submit"),
        // inputValidator: (val) => {
        //   if (!val) return "Enter something to show instead of zero";
        // },
      }).then((val) => {
        this.zerosAs = val.value; // allow null value to clear
        // if (val.value) this.zerosAs = val.value;
      });
    },
    toggleOutOfStock(o) {
      o.out_of_stock = !o.out_of_stock;
      this.z += 1;
    },
    deleteOptionsMenu() {
      if (!this.m) {
        this.close(); // if not saved to DB yet then just close
        return;
      }
      var red = this.bulmaColor("danger");
      this.$swal({
        title: `<i class="fa fa-bomb" style="color: ${red}" />`,
        html: `Are you sure you want to soft delete this options menu?`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: this.$t("cancel"),
        confirmButtonColor: red,
      }).then((val) => {
        if (val.value) {
          var loader = this.loadingDots("blue");
          this.$store
            .dispatch("deleteBlob", this.m.id)
            .then(() => {
              this.infoToast("Options menu deleted!", "top");
              this.$emit("update", null);
              this.close();
            })
            .catch((err) => this.apiError(err))
            .finally(() => loader.hide());
        }
      });
    },

    init() {
      if (this.opts) {
        this.type = this.opts.type;
        this.parentItemID = this.opts.parent_item_id;
      }
      if (!this.m) return;
      this.multipleConstraint = this.m.data.multiple_constraint || "none";
      this.multipleN = this.m.data.multiple_n || 1;
      this.parentItemID = this.m.data.parent_item_id;
      this.type = this.m.data.type;
      this.condition = this.m.data.condition;
      this.name = this.m.data.name;
      this.select = this.m.data.select;
      this.required = this.m.data.required;
      this.allowMultiple = this.m.data.allow_multiple;
      this.showZeros = this.m.data.show_zero;
      this.zerosAs = this.m.data.zeros_as;
      this.items = this.m.data.items;
      this.languages.forEach((l) => {
        this.names[l] = this.m.data[l];
        if (this.m.data.instruction) {
          this.isShowInstruction = true;
          this.instructions[l] = this.m.data.instruction[l];
        }
      });
      this.setContentLang("en", true);
    },
    setContentLang(lang, isInit) {
      if (!isInit) this.saveContent();
      this.contentLang = lang;
      this.setContent();
    },
    setContent() {
      this.items.forEach((o) => {
        if (o[this.contentLang]) {
          o.name = o[this.contentLang].name;
          o.description = o[this.contentLang].description;
        }
      });
      //   this.names[this.contentLang] = this.name;
      if (this.m) {
        this.name = this.m.data[this.contentLang];
        if (this.m.data.instruction) {
          this.instruction = this.m.data.instruction[this.contentLang];
        }
      }
    },
    saveContent() {
      this.items.forEach((o) => {
        o[this.contentLang] = {
          name: o.name,
          description: o.description,
        };
        if (!o.id) o.id = shortid.generate(); // should change id if name/price changes
      });
      this.names[this.contentLang] = this.name;
      if (this.instruction) {
        this.instructions[this.contentLang] = this.instruction;
      }
      if (this.m) {
        this.m.data[this.contentLang] = this.name;
        // this.m.data.instruction[this.contectLang] = this.instruction;
      }
    },
    // invalidItems() { // for more complex items like main menu where return bool
    cleanItems() {
      if (!this.items.length) return; // nothing to clean
      var last = this.items[this.items.length - 1];
      if (!last.name) {
        this.items.pop();
        this.infoToast("Removed blank item", "top");
      }
      this.items.forEach((i) => {
        if (!i.price) i.price = 0;
      });
    },
    editDescription(o) {
      if (!o.name) {
        this.warningToast("Set item name first");
        return;
      }
      this.$swal({
        input: "textarea",
        title: o.name,
        // imageUrl: o.pic || this.$store.state.errorProfilePic,
        // imageHeight: "200px",
        inputValue: o.description || "",
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonText: this.$t("Save Description"),
      }).then((val) => {
        if (val.value) {
          console.log("description", val.value);
          o.description = val.value;
        }
      });
    },
    preDuplicateOptions() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='margin-bottom:12px'>
        <i class='fa fa-copy'></i>&nbsp;Duplicate Options</p>
        <p>New options will be created with name:</p>
        <p><b>Copy of ${this.name}</b></p>
        </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Create",
      }).then((val) => {
        if (val.value) {
          this.saveOptionsMenu(false); // first save existing
          this.$nextTick(() => this.duplicateOptionsMenu());
        }
      });
    },
    duplicateOptionsMenu() {
      // save duplicate options as "Copy of ..."
      var duplicate = this.deepCopy(this.m);
      duplicate.id = null; // clear the ID so it createds a new one
      duplicate.data.name = `Copy of ${duplicate.data.name}`;
      this.languages.forEach((l) => {
        duplicate.data[l] = `Copy of ${this.names[l] || duplicate.data.name}`;
      });
      duplicate.data.items.forEach((o) => {
        o.id = `c${o.id}`; // shortid.generate(); // new IDs
      });
      var loader = this.loadingDots("purple");
      this.$store
        .dispatch("saveBlob", duplicate)
        .then((res) => {
          console.log("duplicated options menu", res.data);
          this.successToast("Duplicated menu saved!", "top");
          this.$emit("update", res.data);
          this.close();
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    saveOptionsMenu(close) {
      if (this.disableSave) {
        var msg = `You must set a name<br>and select single or multiple`;
        this.warningToast(msg);
        return;
      }
      if (!this.multipleConstraintNone && !this.multipleN) {
        this.multipleConstraint = "none"; // multiple N is zero, so no constraint
      }
      this.cleanItems();
      this.saveContent();
      if (this.select === "multiple" && this.multipleConstraint === "exactly") {
        this.required = true;
      }
      var data = {
        name: this.name,
        required: this.required,
        select: this.select,
        show_zero: this.showZero,
        zeros_as: this.zerosAs,
        items: this.items,
        allow_multiple: this.allowMultiple,
        multiple_constraint: this.multipleConstraint || "none", // if select === "multiple", [none, up_to, exactly]
        multiple_n: parseInt(this.multipleN || 0), // if multiple_constraint !== "none"
        instruction: this.instructions,
      };
      if (this.condition) {
        data.condition = this.condition; // e.g. large pizza
      }
      if (this.type) {
        data.type = this.type;
      }
      if (this.parentItemID) {
        data.parent_item_id = this.parentItemID;
      }
      this.languages.forEach((l) => {
        data[l] = this.names[l] || this.name;
      });
      var optionsMenu = {
        parent_type: "workflow",
        parent_id: this.workflow.id,
        blob_type: "options_menu",
        data: data,
      };
      if (this.m) optionsMenu.id = this.m.id; // if editing existing
      var loader = this.loadingDots("navy");
      this.$store
        .dispatch("saveBlob", optionsMenu)
        .then((res) => {
          console.log("saved options menu", res.data);
          this.infoToast("Options menu saved!", "top");
          this.$emit("update", res.data);
          if (close) this.close();
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    addItemToMenu() {
      //   if (this.invalidItems()) return;
      this.cleanItems();
      var id = shortid.generate();
      var o = { id: id, name: null, description: null, price: null }; //, pic: null };
      this.items.push(o);
      // scroll to bottom of menu to see new item
      var opts = { top: 99999, behavior: "smooth" };
      this.$nextTick(() => this.$refs.scrollable.scrollTo(opts));
    },
    deleteMenuItem(idx) {
      var item = this.items[idx];
      if (!item.name && !item.price && !item.description) {
        this.items.splice(idx, 1); // if item is empty
        return; // delete without double confirmation
      }
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-times-circle'></i>&nbsp;Delete Item</p>
        <p>Are you sure you want to delete this item?
        </p>
        </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonColor: this.bulmaColor("danger"),
        confirmButtonText: "Yes, Delete It",
      }).then((val) => {
        if (val.value) this.items.splice(idx, 1);
      });
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: white;
  z-index: 21;
  /* backdrop-filter: blur(3px); */
}
.wrapper {
  padding: 16px;
}
.subtitle {
  text-align: left;
  font-weight: 500;
  margin-bottom: 10px;
}
.delete {
  position: absolute;
  right: 12px;
  top: 12px;
}
.notification {
  padding: 10px;
  margin-bottom: 16px;
}
.menu {
  overflow: scroll;
  /* max-height: calc(100vh - 310px); */
  max-height: calc(100vh - 200px);
  /* background-color: rgba(238, 238, 238, 0.3); */
  padding-bottom: 200px;
}
.hint {
  /* font-weight: 500; */
  opacity: 0.6;
}
.notes i {
  white-space: normal;
}
.notes p {
  margin-top: -4px;
  border: 1px solid rgb(240, 240, 240);
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 4px;
  white-space: pre-wrap;
}
.item {
  /* box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2); */
  margin-bottom: 10px;
}
.button.is-small.is-rounded {
  padding: 0 6px;
}
.settings-main {
  position: absolute;
  bottom: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(2px);
  width: 100vw;
}
.settings-wrapper {
  position: fixed;
  bottom: 0;
  width: 100vw;
  text-align: left;
  padding: 10px;
  padding-top: 14px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  box-shadow: 0px -2px 2px rgba(100, 100, 100, 0.2);
}
.list-item {
  text-align: left;
}
.pl-0 {
  padding-left: 0;
}
.pr-0 {
  padding-right: 0;
}
.buttons {
  margin-bottom: 0;
}
.buttons .button {
  padding: 0 8px;
}
.list {
  max-height: calc(100vh - 270px);
  overflow: scroll;
  margin-bottom: 10px;
}
.bg-dark {
  background-color: rgb(142, 142, 142);
}
.bg-pink {
  background-color: pink;
}
.item-name {
  font-size: 1.2em;
  display: inline-block;
  max-width: calc(100vw - 104px);
}
.advanced-settings {
  font-size: 0.8em;
  font-weight: 450;
  color: grey;
}
.input-label {
  position: absolute;
  top: -10px;
  right: 10px;
  background-color: rgba(255, 255, 255, 0.9);
  color: grey;
  font-size: 0.8em;
  font-weight: 500;
  padding: 1px 3px;
}
.bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100vw;
  padding: 10px;
  background-color: white;
  box-shadow: 0 0 3px grey;
}
</style>

<style>
.swal2-textarea {
  color: lightgreen;
}
</style>